/**
 * Laadt de Futy-widget: de WhatsApp-/leadbotknop rechtsonder in de winkel.
 *
 * WAAR DIT HOORT
 * Als asset, ingeladen onderaan de <body>.
 *
 * WAAROM NIET IN GTM
 * GTM draait op deze shop uitsluitend in de sandbox van de Shopify Custom
 * Pixel: een eigen iframe zonder toegang tot de DOM van de winkelpagina. Een
 * Custom HTML-tag zou dit script dus in dat onzichtbare iframe injecteren. De
 * tag vuurt netjes en de widget verschijnt nergens.
 *
 * CONSENT
 * Laadt bewust altijd, niet achter de cookiebanner: het is een contactkanaal
 * dat de bezoeker zelf aanzet. Futy zet daarbij wel eigen cookies voor
 * gebruikersstatistieken; de afweging staat in vendor/futy.yaml.
 *
 * GEEN TEMPLATE-LITERALS
 * De stukken hieronder worden met + aan elkaar geplakt, niet met backticks.
 * Een template-literal gebruikt dezelfde dollar-accolade-notatie als onze
 * placeholders, en `gtm snippets` kan die twee niet uit elkaar houden: hij
 * ziet er een registerwaarde in die niet bestaat en stopt.
 */
(function (document, tagnaam) {
  var KEY = "67b5f563a4a73";
  // Zonder key laadt de widget wel, maar hoort hij bij geen enkel account en
  // blijft het bij een lege knop.
  if (!KEY) return;

  window.Futy = { key: KEY };

  var script = document.createElement(tagnaam);
  script.async = true;
  // legacy.js draagt de polyfills voor browsers zonder Promise of fetch mee;
  // de rest krijgt de kleinere bundel.
  var bundel = window.Promise && window.fetch ? "modern.js" : "legacy.js";
  script.src = "https://v1.widget.futy.io/js/futy-widget-" + bundel;

  // Futy's eigen snippet hangt hem vóór het eerste script-element. Dat werkt
  // hier ook, maar dit bestand kan als asset het enige script op de pagina
  // zijn; dan is er niets om vóór te gaan staan.
  var eerste = document.getElementsByTagName(tagnaam)[0];
  if (eerste && eerste.parentNode) {
    eerste.parentNode.insertBefore(script, eerste);
  } else {
    (document.body || document.documentElement).appendChild(script);
  }
})(document, "script");
